import styled from '@mui/material/styles/styled';
import Toolbar from '@mui/material/Toolbar';
import Tab from '@mui/material/Tab';

export const LogoContainer = styled('img')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'block',
    height:'auto',
    width: 170,
  }
}));
export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  height: 80,
  color: theme.palette.text.primary,
  background: theme.palette.background.paper,
  display: 'flex',
  justifyContent: 'space-between',
  boxShadow: '0 1px 5px 0 rgba(127, 127, 227, 0.21)',
  zIndex: 1,
}));

export const StyledTab = styled(Tab)(() => ({
  textTransform: 'none',
  fontSize: '1.25rem',
  fontWeight: '600',
}));